var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "24px",
    viewBox: "0 0 22 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/General/Delete") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.6363636,7.63636364 L19.6363636,21 C19.6363636,22.6568542 18.2932179,24 16.6363636,24 L5.18181818,24 C3.52496393,24 2.18181818,22.6568542 2.18181818,21 L2.18181818,7.63636364 L19.6363636,7.63636364 Z M6.07438017,10.6494978 C5.65727,10.6494978 5.31306037,10.9616221 5.26257315,11.3650486 L5.25619835,11.4676796 L5.25619835,20.3077517 C5.25619835,20.7596211 5.62251082,21.1259336 6.07438017,21.1259336 C6.49149033,21.1259336 6.83569996,20.8138093 6.88618719,20.4103827 L6.89256198,20.3077517 L6.89256198,11.4676796 C6.89256198,11.0158103 6.52624951,10.6494978 6.07438017,10.6494978 Z M10.9834711,10.6494978 C10.5663609,10.6494978 10.2221513,10.9616221 10.1716641,11.3650486 L10.1652893,11.4676796 L10.1652893,20.3077517 C10.1652893,20.7596211 10.5316017,21.1259336 10.9834711,21.1259336 C11.4005812,21.1259336 11.7447909,20.8138093 11.7952781,20.4103827 L11.8016529,20.3077517 L11.8016529,11.4676796 C11.8016529,11.0158103 11.4353404,10.6494978 10.9834711,10.6494978 Z M15.6446281,10.6494978 C15.2275179,10.6494978 14.8833083,10.9616221 14.8328211,11.3650486 L14.8264463,11.4676796 L14.8264463,20.3077517 C14.8264463,20.7596211 15.1927588,21.1259336 15.6446281,21.1259336 C16.0617383,21.1259336 16.4059479,20.8138093 16.4564351,20.4103827 L16.4628099,20.3077517 L16.4628099,11.4676796 C16.4628099,11.0158103 16.0964974,10.6494978 15.6446281,10.6494978 Z M10.9612875,8.8817842e-16 C12.3738296,6.28698642e-16 13.5189213,1.14509164 13.5189213,2.55763375 L13.518,3.272 L20.1818182,3.27272727 C21.0855569,3.27272727 21.8181818,4.00535223 21.8181818,4.90909091 C21.8181818,5.81282959 21.0855569,6.54545455 20.1818182,6.54545455 L1.63636364,6.54545455 C0.732624955,6.54545455 8.18230907e-14,5.81282959 8.17124146e-14,4.90909091 C8.16017385e-14,4.00535223 0.732624955,3.27272727 1.63636364,3.27272727 L8.40365395,3.27291464 L8.40365376,2.55763375 C8.40365376,1.14509164 9.5487454,1.1476582e-15 10.9612875,8.8817842e-16 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Profile-&-Settings-\\uD83D\\uDC81\\uD83C\\uDFFB\\u200D\\u2640\\uFE0F",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Edit-Profile---Photo-Viewer-Private",
    transform: "translate(-333.000000, -17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/General/Delete",
    transform: "translate(329.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(4.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colors/Gray/Gray-3",
    mask: "url(#mask-2)",
    fill: "#999999"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.000000, -3.000000)",
    id: "Base"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 30,
    height: 30
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.46ddae6bd0d0a1f92b3f2ea23a0975ad.svg";
export { ForwardRef as ReactComponent };